import { render, staticRenderFns } from "./ester-synthese-mechanismus.vue?vue&type=template&id=015164d7&"
import script from "./ester-synthese-mechanismus.vue?vue&type=script&lang=js&"
export * from "./ester-synthese-mechanismus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports